import { useProductPreviewData } from '../../hooks/useProductPreviewData.js'

import { Button }        from '../Button/index.js'
import { DataGrid }      from '../DataGrid/index.js'
import { UnitPlanThumb } from '../UnitPlanThumb/index.js'

import styles from './ProductPreviewMobile.module.scss'

/**
 * Mobile-only product preview body for BottomSheet contexts.
 * Header row (id / badges / actions) is intentionally external.
 */
export function ProductPreviewMobile({
  className,
  onAction,
  product,
}) {

  const deferPlanMs = 90

  const {
    getProductsCategoryString,
    gridItems,
    isPlanMounted,
    showPlanThumb,
    logoSrc,
    planVisible,
    projectDataUrl
  } = useProductPreviewData({
    product,
    deferPlanMs,
  })
  
  if (!product) return null

  const rootClass = [styles.holder, className].filter(Boolean).join(' ')

  return (
    <div className={rootClass}>
      <div className={styles.infoPane}>
        <div className={styles.dataContainer}>
          <DataGrid 
            size="small" 
            columns={3} 
            items={gridItems}
          />
        </div>

          <div className={styles.action}>
            <Button
              cta
              type="button"
              kind="wide"
              size="large"
              onClick={() => onAction()}
            >
              {getProductsCategoryString(
                'open',
                product.product_category,
                { id: product.id_original ?? product.number ?? product.id_cad }
              )}
            </Button>
          </div>
      </div>

      {
      showPlanThumb && 
      projectDataUrl && (
        <aside className={styles.thumbPane}>
          {isPlanMounted
            ? (
              <UnitPlanThumb
                product={product}
                projectDataUrl={projectDataUrl}
                logoSrc={logoSrc}
                planVisible={planVisible}
              />
            ) : (
              <div className={styles.thumbPlaceholder} aria-hidden="true" />
            )}
        </aside>
      )}
    </div>
  )
}
